import type { IconProps } from "./icon-types";

/**
 * 처음으로 이동(|←) — 재생바 goToStart. 경계 막대 + 화살표가 "경계로 이동"을
 * 명시한다 — «»(AngleDouble류)는 빨리감기로 오독됨(SWD-819 UI 검증).
 *
 * Lucide의 `LuArrowLeftToLine` geometry를 정적 SVG로 인라인 — c6 패키지는 외부
 * 아이콘 라이브러리를 런타임 의존하지 않는다(RFC-design-system-split §아이콘).
 */
export const SkipToStartIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M3 19V5" />
    <path d="m13 6-6 6 6 6" />
    <path d="M7 12h14" />
  </svg>
);
